// tslint:disable:no-any

import * as types from './actionTypes';
import { DiveService } from '../services/DiveService';

export const loadDivesSuccess = (dives: any) => ({
    type: types.LOAD_DIVES_SUCCESS,
    dives
});

export const loadDives = () => async (dispatch: any) => {
    const dives = await DiveService.getInstance().loadDives();
    if (dives != undefined) {
        dispatch(loadDivesSuccess(dives));
    } else {
        // tslint:disable-next-line:no-console
        console.log('An error occured.');
    }
};

export const loadSharedDivesSuccess = (dives: any) => ({
    type: types.LOAD_SHARED_DIVES_SUCCESS,
    dives
});

export const loadSharedDives = () => async (dispatch: any) => {
    const dives = await DiveService.getInstance().loadSharedDives();
    if (dives != undefined) {
        dispatch(loadSharedDivesSuccess(dives));
    } else {
        // tslint:disable-next-line:no-console
        console.log('An error occured.');
    }
};

export const loadDiveDataSuccess = (dive: any) => ({
    type: types.LOAD_DIVE_DATA_SUCCESS,
    dive
});

export const loadDiveData = (diveId: string) => async (dispatch: any) => {
    const dive = await DiveService.getInstance().loadDiveData(diveId);
    if (dive != undefined) {
        dispatch(loadDiveDataSuccess(dive));
    } else {
        // tslint:disable-next-line:no-console
        console.log('An error occured.');
    }
};

export const loadSharedDiveDataSuccess = (dive: any) => ({
    type: types.LOAD_DIVE_DATA_SUCCESS,
    dive
});

export const loadSharedDiveData = (diveId: string) => async (dispatch: any) => {
    const dive = await DiveService.getInstance().loadSharedDiveData(diveId);
    if (dive != undefined) {
        dispatch(loadSharedDiveDataSuccess(dive));
    } else {
        // tslint:disable-next-line:no-console
        console.log('An error occured.');
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/diveActions.ts